import { useEffect } from "react";
import mixpanel from "mixpanel-browser";
import { useSetRecoilState } from "recoil";
import { webTestTypeAtom } from "../../../recoil/webTestTypeAtom";
import { webFunnelApi } from "../../../api/webFunnelApi";
import useMixpanelProfileMkt from "../../../hooks/useMixpanelProfileMkt";

const WEB_FUNNEL_DISTINCT_ID_STORAGE_KEY = "WEB_FUNNEL_DISTINCT_ID";
const WEB_FUNNEL_ONBOARDING_TYPE_STORAGE_KEY = "WEB_FUNNEL_ONBOARDING_TYPE";
const FIXED_ONBOARDING_TYPE = "j";

export default function V6Initializer() {
  const setWebTestType = useSetRecoilState(webTestTypeAtom);
  const setPromotionPeople = useMixpanelProfileMkt("v6");

  useEffect(() => {
    let isMounted = true;

    const persistOnboardingType = (onboardingType: string) => {
      localStorage.setItem(
        WEB_FUNNEL_ONBOARDING_TYPE_STORAGE_KEY,
        onboardingType
      );
    };

    const syncWebFunnelState = (onboardingType: string) => {
      if (!isMounted) return;
      setWebTestType({ onboardingType });
      const mixpanelProperties: { [key: string]: string } = {
        "테스트 유형": "C",
        "로그인 페이지 유형": "E",
        "온보딩 유형": onboardingType.toUpperCase(),
      };
      setPromotionPeople(mixpanelProperties);
    };

    const initV6State = async () => {
      const waitForMixpanelAndInit = async (retryCount: number) => {
        if (!isMounted) return;

        const instance = (mixpanel as any).promotion;
        const distinctId = instance?.get_distinct_id?.();

        if (distinctId) {
          instance?.identify?.(distinctId);
          localStorage.setItem(WEB_FUNNEL_DISTINCT_ID_STORAGE_KEY, distinctId);

          try {
            await webFunnelApi.begin(distinctId, FIXED_ONBOARDING_TYPE);
          } catch (e) {
            console.error("Failed to call webFunnelApi.begin", e);
          }

          persistOnboardingType(FIXED_ONBOARDING_TYPE);
          syncWebFunnelState(FIXED_ONBOARDING_TYPE);
        } else {
          if (retryCount > 0) {
            setTimeout(() => waitForMixpanelAndInit(retryCount - 1), 200);
          } else {
            persistOnboardingType(FIXED_ONBOARDING_TYPE);
            syncWebFunnelState(FIXED_ONBOARDING_TYPE);
          }
        }
      };

      waitForMixpanelAndInit(50);
    };

    initV6State();

    return () => {
      isMounted = false;
    };
  }, [setWebTestType, setPromotionPeople]);

  return null;
}
